import { CSSProperties } from 'react';

export const pageWrapper = {
  display: 'flex',
  paddingTop: '20px',
  flexDirection: 'column',
  width: '100%',
  minHeight: 'calc(100vh - 120px)',
  alignItems: 'center',
  gap: '10px',
  maxWidth: '99%',
  margin: '0 auto',
  marginTop: '10px',
  padding: '0px 0px',
} as CSSProperties;
